/* eslint-disable custom/no-restricted-translation-jsx-untranslated-children-text */
import React from 'react';

import { Typography } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';
import { Locale } from '@kamernet/core/Intl/types';
import { NavLink } from '@kamernet/core/Routing/NavLink';
import { ROUTES } from '@kamernet/core/Routing/routes';
import { ListingsSearchCategory } from '@kamernet/core/Routing/routes/ListingsSearch';

import styles from './Content.module.css';

export const ContentCountryAntisquat = () => {
  const { locale } = useIntl();
  const searchCategories = [ListingsSearchCategory.Antisquat];

  return locale === Locale.en ? (
    <React.Fragment>
      <Typography variant="h1" className={styles.title}>
        Anti-Squat in the Netherlands
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        Are you searching for anti squat housing in the Netherlands? Look no
        further! Discover the benefits of anti-squatting living and find unique
        rental housing that fits your budget and lifestyle. Find an anti-squat
        in the Netherlands today and enjoy the benefits of affordable housing
        while contributing to the preservation of vacant properties.
      </Typography>
      <Typography variant="h3" className={styles.title}>
        Why choose to rent anti-squatting?
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        By participating in an anti squatting arrangement, you can access
        housing solutions that are both cost-effective and community-oriented.
        Antisquat properties often offer a range of living spaces from
        residential units to commercial or industrial spaces providing diverse
        options to suit your needs.
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        Anti Squatting not only provides a viable solution to affordable housing
        but also allows you to live in unique and character-filled properties
        with flexibility and affordability. Register now and discover through
        Kamernet the perfect anti-squatting apartment in the Netherlands that
        meets your needs and preferences.
      </Typography>
      <Typography variant="h3" className={styles.title}>
        Useful Links:
      </Typography>
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'almere', searchCategories },
          Locale.en,
        )}
      >
        Almere anti-squat
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'nijmegen', searchCategories },
          Locale.en,
        )}
      >
        Nijmegen anti-squat
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'hilversum', searchCategories },
          Locale.en,
        )}
      >
        Hilversum anti-squat
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'eindhoven', searchCategories },
          Locale.en,
        )}
      >
        Eindhoven anti-squat
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'hoofddorp', searchCategories },
          Locale.en,
        )}
      >
        Hoofddorp anti-squat
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'zaandam', searchCategories },
          Locale.en,
        )}
      >
        Zaandam anti-squat
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'arnhem', searchCategories },
          Locale.en,
        )}
      >
        Arnhem anti-squat
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'tilburg', searchCategories },
          Locale.en,
        )}
      >
        Tilburg anti-squat
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'enschede', searchCategories },
          Locale.en,
        )}
      >
        Enschede anti-squat
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'amersfoort', searchCategories },
          Locale.en,
        )}
      >
        Amersfoort anti-squat
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'zeist', searchCategories },
          Locale.en,
        )}
      >
        Zeist anti-squat
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'breda', searchCategories },
          Locale.en,
        )}
      >
        Breda anti-squat
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'maastricht', searchCategories },
          Locale.en,
        )}
      >
        Maastricht anti-squat
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'nieuwegein', searchCategories },
          Locale.en,
        )}
      >
        Nieuwegein anti-squat
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'schiedam', searchCategories },
          Locale.en,
        )}
      >
        Schiedam anti-squat
      </NavLink.Anchor>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <Typography variant="h1" className={styles.title}>
        Antikraak in Nederland
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        Ben je op zoek naar antikraakwoningen in Nederland? Zoek dan niet
        verder! Ontdek de voordelen van antikraak wonen en vindt een unieke
        huurwoning die past bij je budget en levensstijl. Vind vandaag nog een
        antikraakwoning in Nederland en geniet van de voordelen van betaalbaar
        wonen terwijl je bijdraagt aan het behoud van leegstaand vastgoed.
      </Typography>
      <Typography variant="h3" className={styles.title}>
        Waarom kiezen voor antikraak huren?
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        Wanneer je deelneemt aan een antikraakregeling, krijg je toegang tot
        huisvestingsoplossingen die zowel voordelig als gemeenschapsgericht
        zijn. Antikraakpanden bieden vaak een breed aanbod aan woningen, van
        wooneenheden tot commerciële of industriële ruimtes, waardoor er
        verschillende opties zijn om aan je behoeften te voldoen.
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        Antikraak biedt niet alleen een betaalbare woonoplossing, maar stelt je
        ook in staat om flexibel en betaalbaar te wonen in unieke en
        karaktervolle panden. Schrijf je nu in en ontdek via Kamernet de
        perfecte antikraak woning in Nederland die voldoet aan jouw wensen en
        voorkeuren.
      </Typography>
      <Typography variant="h3" className={styles.title}>
        Handige links:
      </Typography>
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'almere', searchCategories },
          Locale.nl,
        )}
      >
        Antikraak Almere
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'nijmegen', searchCategories },
          Locale.nl,
        )}
      >
        Antikraak Nijmegen
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'hilversum', searchCategories },
          Locale.nl,
        )}
      >
        Antikraak Hilversum
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'eindhoven', searchCategories },
          Locale.nl,
        )}
      >
        Antikraak Eindhoven
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'hoofddorp', searchCategories },
          Locale.nl,
        )}
      >
        Antikraak Hoofddorp
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'zaandam', searchCategories },
          Locale.nl,
        )}
      >
        Antikraak Zaandam
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'arnhem', searchCategories },
          Locale.nl,
        )}
      >
        Antikraak Arnhem
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'tilburg', searchCategories },
          Locale.nl,
        )}
      >
        Antikraak Tilburg
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'enschede', searchCategories },
          Locale.nl,
        )}
      >
        Antikraak Enschede
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'amersfoort', searchCategories },
          Locale.nl,
        )}
      >
        Antikraak Amersfoort
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'zeist', searchCategories },
          Locale.nl,
        )}
      >
        Antikraak Zeist
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'breda', searchCategories },
          Locale.nl,
        )}
      >
        Antikraak Breda
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'maastricht', searchCategories },
          Locale.nl,
        )}
      >
        Antikraak Maastricht
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'nieuwegein', searchCategories },
          Locale.nl,
        )}
      >
        Antikraak Nieuwegein
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'schiedam', searchCategories },
          Locale.nl,
        )}
      >
        Antikraak Schiedam
      </NavLink.Anchor>
    </React.Fragment>
  );
};
